import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { useFormik, FormikProvider, Field, ErrorMessage } from "formik";
import React, { useState} from "react";
import { useHistory } from "react-router-dom";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, Table } from "react-bootstrap";
import moment from "moment-timezone";
import jsPDF from "jspdf";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { AiOutlineSearch } from "react-icons/ai";
import { FaFastBackward } from "react-icons/fa";
import Select from "react-select";
import { store } from "../../../App";
import { Link } from "@material-ui/core";
import { FixedSizeList as List } from 'react-window';
import debounce from 'lodash/debounce';

function SubledgerReportNew() {
  const history = useHistory();
  const [Headsnmaelist, setHeadsnmHeadsnmaelist] = useState([]);
  const [subHeadsnmaelist, setSubHeadsnmaelist] = useState([]);
  const [tableenable, settableenable] = useState(false);
  const [tableData, settabledata] = useState();
  const [searchText, setSearchText] = useState("");
  const [distList, setDistList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSubheadid, setSelectedSubHeadid] = useState("")



  const getPdf = (payment_receipt_id) => {
    HousingService.getPaymentPdf(payment_receipt_id).then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );

      let tab = window.open();

      tab.location.href = url;
    });
  };


  const today = new Date().toISOString().split('T')[0];




  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const formik = useFormik({
    initialValues: {
      fromDate: "",
      toDate: "",
      headid: "All",
      subheadid: "All",
      transactionType: "",
      district: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.district) { errors.district = "District is required"; }
      if (!values.fromDate) { errors.fromDate = "From Date is required"; }
      if (!values.toDate) { errors.toDate = "To Date is required"; }
      if (values.fromDate && values.toDate && values.fromDate > values.toDate) { errors.toDate = "To Date must be greater than From Date"; }
      return errors;
    },

    onSubmit: async (values) => {
      store.dispatch({ type: "SHOW_SPINNER" });
      let params = { fromDate: moment(values.fromDate).format("DD/MM/YYYY"), toDate: moment(values.toDate).format("DD/MM/YYYY"), headid: values.headid, subheadseqid: values.subheadid, district: values.district };
      await new Promise((resolve) => setTimeout(resolve, 2000));
      HousingService.GetSubLeadger_Report(params).then((res) => {
        settabledata(res.data);
        settableenable(true);
      });
      store.dispatch({ type: "HIDE_SPINNER" });
    },
  });
  React.useEffect(() => {
    setSearchText("")
    HousingService.headsNameApi().then((res) => {
      if (res.data) {
        let options = res.data?.map((item) => ({
          value: item.headid,
          label: item.heads,
        }));
        setHeadsnmHeadsnmaelist([{ value: "All", label: "All" }, ...options]);
      }
    });
    HousingService.CGG_District().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.code}>
              {item.name}
            </option>
          );
        });
        setDistList(options);
      }
    });

  }, []);


  function GeneratePDF() {
    const pageWidth = 1000;
    const pageHeight = 297;
    const imgPath = "/img/APSHCL_logo.png";
    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [pageWidth, pageHeight], });
    const fromDate = moment(formik.values.fromDate).format("DD//MM/YYYY");
    const toDate = moment(formik.values.toDate).format("DD//MM/YYYY");
    const distuser = localStorage.getItem("username");
    const headingText2 = "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
    const headingText3 = ` Subledger Report from : ${fromDate}  to : ${toDate} User: ${distuser} `;
    const headingText4 = "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007";
    doc.setFont("times", "roman");
    const fontSize = 24;
    const textWidth4 = (doc.getStringUnitWidth(headingText4) * fontSize) / doc.internal.scaleFactor;
    const xCoordinate4 = (pageWidth * 1 - textWidth4) / 2;
    const textWidth2 = (doc.getStringUnitWidth(headingText2) * fontSize) / doc.internal.scaleFactor;
    const textWidth3 = (doc.getStringUnitWidth(headingText3) * fontSize) / doc.internal.scaleFactor;
    const tableYStart = 50;
    doc.setFont("times", "roman");
    doc.setFontSize(fontSize);
    const xCoordinate2 = (pageWidth * 1 - textWidth2) / 2;
    doc.text(headingText2, xCoordinate2, 20);
    const xCoordinate3 = (pageWidth * 1 - textWidth3) / 2;
    doc.text(headingText3, xCoordinate3, 45);
    doc.text(headingText4, xCoordinate4, 30);
    doc.addImage(imgPath, "PNG", 5, 5, 40, 40);
    doc.autoTable({
      html: "#my-GeneratePDF",
      theme: "grid",
      tableWidth: "auto",
      columnStyles: { 6: { cellWidth: "wrap" }, },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 },
      styles: { fontSize: 16, },
      columnWidth: { 0: 10, 1: 20, 2: 30, 3: 60, 4: 30, 5: 30 },
    });
    const tableCells = document.querySelectorAll(".times-font");
    tableCells.forEach((cell) => { cell.style.fontFamily = "Times New Roman"; });
    doc.save("Subledger.pdf");
  }

  const handleSelect = (option) => {
    setSelectedSubHeadid(""); // clear the subhead selection
    formik.setFieldValue("headid", option.value);
    formik.setFieldValue("subheadid", ""); // clear formik field
    setSubHeadsnmaelist([]); // clear old subhead list

    const params = { headid: option.value };
    HousingService.getSubHeadsForSubheadLedger(params).then((res) => {
      if (res.data) {
        const options = res.data.map((item) => ({
          value: item.subheadseqid,
          label: item.subheadname,
        }));
        setSubHeadsnmaelist([{ value: "All", label: "All" }, ...options]);
      }
    });
  };




  const debouncedSearch = debounce((inputValue) => {
    setSearchTerm(inputValue);
  }, 100);

  const renderRow = ({ index, style }) => {
    const option = subHeadsnmaelist[index];
    return (
      <div style={style} className="react-select-option">
        {option.label}
      </div>
    );
  };
  const handleSelectSub = (option) => {
    setSelectedSubHeadid(option.value)
    formik.setFieldValue("subheadid", option.value)
  }

  const filteredData = searchText.length > 0 ? tableData?.filter((item) => {
    return (item && Object.keys(item).some((key) => {
      const value = item[key]
      return (value != null && value.toString().toLowerCase().includes(searchText.toLowerCase()))
    }))
  }) : tableData
  return (
    <>
      <NavigationServicesHeader />
      <OFMSUI.Container fluid style={{ width: "90%" }}>
        <OFMSUI.Row>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
            <div className="inner-herbpage-service-title1"> <h1 style={{ marginLeft: "-15px" }}>Sub Ledger</h1> </div>
          </OFMSUI.Col>
          <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
            <button
              className="btn btn-primary btn-sm"
              style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }}
              type="reset"
              onClick={() => history.goBack()}
            >
              <FaFastBackward /> &nbsp;Back
            </button>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <label>From Date <span style={{ color: "red" }}>*</span></label>
                <Field
                  name="fromDate"
                  className={formik.touched.fromDate && formik.errors.fromDate ? "form-control is-invalid" : "form-control"}
                  type="date"
                  onChange={(e) => formik.handleChange(e)}
                  max={today}
                />
                {formik.touched.fromDate && formik.errors.fromDate ? (<div className="invalid-feedback"> {formik.errors.fromDate} </div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <label>To Date <span style={{ color: "red" }}>*</span></label>
                <Field
                  name="toDate"
                  className={formik.touched.toDate && formik.errors.toDate ? "form-control is-invalid" : "form-control"}
                  type="date"
                  onChange={(e) => formik.handleChange(e)}
                  max={today}
                />
                {formik.touched.toDate && formik.errors.toDate ? (<div className="invalid-feedback">{formik.errors.toDate}</div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <label>District <span style={{ color: "red" }}>*</span></label>
                <Field
                  component="select"
                  name="district"
                  className={formik.touched.district && formik.errors.district ? "form-control is-invalid" : "form-control"}
                  onChange={(e) => { formik.handleChange(e); formik.setFieldValue("headid", ""); formik.setFieldValue("subheadid", ""); }}
                >
                  <option value="">Select</option>
                  {distList}
                </Field>
                {formik.touched.district && formik.errors.district ? (<div className="invalid-feedback"> {formik.errors.district} </div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <label>
                  Head Name <span style={{ color: "red" }}>*</span>
                </label>
                <Field
                  name="headid"
                  className={
                    formik.touched.headid && formik.errors.headid
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  render={({ field, form }) => (
                    <Select
                      name="headid"
                      {...field}
                      options={Headsnmaelist}
                      isSearchable
                      onChange={(option) => {
                        formik.setFieldValue("headid", option.value);
                        handleSelect(option); // fetch and reset subheads
                      }}
                      value={
                        Headsnmaelist.find(
                          (option) => option.value === formik.values.headid
                        ) || null
                      }
                    />
                  )}
                />
                {formik.touched.headid && formik.errors.headid ? (
                  <div className="invalid-feedback">{formik.errors.headid}</div>
                ) : null}
              </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={2}>
                <label>
                  Sub-Head <span style={{ color: "red" }}>*</span>
                </label>
                <Field
                  name="subheadid"
                  className={
                    formik.touched.subheadid && formik.errors.subheadid
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  render={({ field, form }) => (
                    <Select
                      name="subheadid"
                      {...field}
                      options={subHeadsnmaelist.filter((option) =>
                        option.label.toLowerCase().includes(searchTerm.toLowerCase())
                      )}
                      isSearchable
                      onInputChange={(inputValue) => debouncedSearch(inputValue)}
                      onChange={(option) => {
                        formik.setFieldValue("subheadid", option.value);
                        setSelectedSubHeadid(option.value);
                        handleSelectSub(option);
                      }}
                      value={
                        subHeadsnmaelist.find(
                          (option) => option.value === formik.values.subheadid
                        ) || null
                      }
                      menuPortalTarget={document.body}
                      menuRenderer={({ children }) => (
                        <div style={{ height: 200, overflowY: "auto" }}>
                          <List
                            height={200}
                            itemCount={subHeadsnmaelist.length}
                            itemSize={35}
                            width="100%"
                          >
                            {renderRow}
                          </List>
                        </div>
                      )}
                    />
                  )}
                />
                {formik.touched.subheadid && formik.errors.subheadid ? (
                  <div className="invalid-feedback">{formik.errors.subheadid}</div>
                ) : null}
              </OFMSUI.Col>


              <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                <center> {" "} <button className="btn btn-primary btn-sm" type="submit" style={{ marginTop: "22px" }} > Submit </button> </center>
              </OFMSUI.Col>
            </OFMSUI.Row>
            &nbsp;

            <OFMSUI.Row>
              {" "}
              {tableenable && (
                <>
                  <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                      <div className="input-group">
                        <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                        <input
                          type="text"
                          id="#filterInput"
                          placeholder="Search"
                          style={{ width: "25%" }}
                          className="form-control input-lg"
                          value={searchText}
                          onChange={(e) => handleSearch(e)}
                        ></input>
                      </div>
                    </OFMSUI.Col>
                    <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                      <button type="button" className="btn btn-success btn-sm" style={{ float: "right", color: "#fff" }} >
                        <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className="download-table-xls-button"
                          table="my-GeneratePDF"
                          filename="SubledgerReport"
                          sheet="tablexls"
                          buttonText="Excel"
                        ></ReactHTMLTableToExcel>
                      </button>
                      <button className="btn btn-danger btn-sm" type="button" onClick={GeneratePDF} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                  <div style={{ overflow: "auto", height: "800px" }}>
                    <Table striped bordered hover id="my-GeneratePDF">
                      <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                        <tr className="table_countshead">
                          <th>S No.</th>
                          <th>Transaction Id No.</th>
                          <th>Date</th>
                          <th style={{ width: "300px" }}> {" "} Description of the Voucher </th>
                          <th style={{ textAlign: "right" }}>Debit</th>
                          <th style={{ textAlign: "right" }}>Credit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData && filteredData.length > 0 ? (
                          filteredData.map((data, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td onClick={() => getPdf(data.payment_receipt_id)}><Link>{data.payment_receipt_id}</Link>
                              </td>
                              <td>{data.to_char}</td>
                              <td>{data.description}</td>
                              <td style={{ textAlign: "right" }}>{parseFloat(data.debit).toFixed(2)}</td>
                              <td style={{ textAlign: "right" }}>{parseFloat(data.credit).toFixed(2)}</td>
                            </tr>
                          ))
                        ) : (
                          <tr> <td colSpan="6" style={{ textAlign: "center", verticalAlign: "middle" }}> No data found </td> </tr>
                        )}
                      </tbody>

                      <tfoot style={{ position: "sticky", bottom: "0px" }}>
                        <tr className="table_countshead">
                          <td colSpan={4} style={{ textAlign: "end" }}> Total Amount in Rs </td>
                          <td style={{ textAlign: "right" }}> {Array.isArray(filteredData) ? filteredData.reduce((a, v) => a + parseFloat(v.debit), 0) : "0"} </td>
                          <td style={{ textAlign: "right" }}> {Array.isArray(filteredData) ? filteredData.reduce((a, v) => a + parseFloat(v.credit), 0) : "0"} </td>
                        </tr>
                      </tfoot>

                    </Table>
                  </div>
                </>
              )}
            </OFMSUI.Row>
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default SubledgerReportNew;





